<mat-card>
    <mat-card-header>
        <mat-card-title class="mat-card-title-custom">{{'contract_enterprise_receive.card_tile' | translate}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
        <!-- Filter -->
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel expanded="true" class="mt-3">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'report_components.filter_title' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <form #myForm="ngForm" class="pb-3">
                    <div class="row">
                        <!-- Chủ thể lập -->
                        <div class="col-xl-2 col-12">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.createEnterpriseName = documents.createEnterpriseName == undefined ? '' : (documents.createEnterpriseName + '').trim()"
                                    #focusInput matInput [placeholder]="'search_form.subject_create' | translate"
                                    name="createEnterpriseName" [(ngModel)]="documents.createEnterpriseName"
                                    maxlength="200" autocomplete="off">
                                <button mat-button *ngIf="documents.createEnterpriseName" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="documents.createEnterpriseName=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Bên tham gia ký kết -->
                        <div class="col-xl-2 col-12">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.signEnterpriseNameEmail = documents.signEnterpriseNameEmail == undefined ? '' : (documents.signEnterpriseNameEmail + '').trim()"
                                    #focusInput matInput [placeholder]="'search_form.contracting_party' | translate"
                                    name="signEnterpriseNameEmail" [(ngModel)]="documents.signEnterpriseNameEmail"
                                    maxlength="200" autocomplete="off">
                                <button mat-button *ngIf="documents.signEnterpriseNameEmail" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="documents.signEnterpriseNameEmail=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian nhận (từ ngày) -->
                        <div class="col-xl-2 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'search_form.received_date_from' | translate }}</mat-label>
                                <input matInput [matDatepicker]="receiveFromDateRef" [max]="documents.receiveToDate"
                                    #receiveFromDateCtrl="ngModel"
                                    (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['receiveFromDate'])"
                                    name="receiveFromDate" #pickerInput [(ngModel)]="documents.receiveFromDate"
                                    maxlength="200" (focus)="receiveDateErr = 'receiveFromDate'" autocomplete="off" />
                                <mat-datepicker-toggle matSuffix [for]="receiveFromDateRef">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                                        [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #receiveFromDateRef></mat-datepicker>
                                <mat-error *ngIf="receiveFromDateCtrl?.errors?.matDatepickerParse">
                                    {{'validation.format_of_date' | translate}}
                                </mat-error>
                                <mat-error
                                    *ngIf="receiveFromDateCtrl?.errors?.matDatepickerMax && receiveDateErr == 'receiveFromDate'">
                                    {{ 'search_form.received_date_from' | translate }}
                                    {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                                    {{ 'search_form.received_date_to' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian nhận (đến ngày) -->
                        <div class="col-xl-2 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'search_form.received_date_to' | translate }}</mat-label>
                                <input matInput [matDatepicker]="receiveToDateRef" [min]="documents.receiveFromDate"
                                    (change)="this.commonService.resetDatePicker(pickerInput1.value, this.ngForm.controls['receiveToDate'])"
                                    name="receiveToDate" #pickerInput1 [(ngModel)]="documents.receiveToDate"
                                    #receiveToDateCtrl="ngModel" maxlength="200"
                                    (focus)="receiveDateErr = 'receiveToDate'" autocomplete="off" />
                                <mat-datepicker-toggle matSuffix [for]="receiveToDateRef">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                                        [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #receiveToDateRef></mat-datepicker>
                                <mat-error *ngIf="receiveToDateCtrl?.errors?.matDatepickerParse">
                                    {{'validation.format_of_date' | translate}}
                                </mat-error>
                                <mat-error
                                    *ngIf="receiveToDateCtrl?.errors?.matDatepickerMin && receiveDateErr == 'receiveToDate'">
                                    {{ 'search_form.received_date_to' | translate }}
                                    {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                                    {{ 'search_form.received_date_from' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian hết hạn (từ ngày) -->
                        <div class="col-xl-2 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'search_form.expired_date_from' | translate }}</mat-label>
                                <input matInput [matDatepicker]="expiredFromDateRef" [max]="documents.expiredToDate"
                                    #expiredFromDateCtrl="ngModel"
                                    (change)="this.commonService.resetDatePicker(pickerInput2.value, this.ngForm.controls['expiredFromDate'])"
                                    name="expiredFromDate" #pickerInput2 [(ngModel)]="documents.expiredFromDate"
                                    maxlength="200" (focus)="expiredDateErr = 'expiredFromDate'" autocomplete="off" />
                                <mat-datepicker-toggle matSuffix [for]="expiredFromDateRef">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                                        [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #expiredFromDateRef></mat-datepicker>
                                <mat-error *ngIf="expiredFromDateCtrl?.errors?.matDatepickerParse">
                                    {{'validation.format_of_date' | translate}}
                                </mat-error>
                                <mat-error
                                    *ngIf="expiredFromDateCtrl?.errors?.matDatepickerMax && expiredDateErr == 'expiredFromDate'">
                                    {{ 'search_form.expired_date_from' | translate }}
                                    {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                                    {{ 'search_form.expired_date_to' | translate }}
                                </mat-error>

                            </mat-form-field>
                        </div>

                        <!-- Thời gian hết hạn (đến ngày) -->
                        <div class="col-xl-2 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'search_form.expired_date_to' | translate }}</mat-label>
                                <input matInput [matDatepicker]="expiredToDateRef" [min]="documents.expiredFromDate"
                                    (change)="this.commonService.resetDatePicker(pickerInput3.value, this.ngForm.controls['expiredToDate'])"
                                    name="expiredToDate" #pickerInput3 [(ngModel)]="documents.expiredToDate"
                                    #expiredToDateCtrl="ngModel" maxlength="200"
                                    (focus)="expiredDateErr = 'expiredToDate'" autocomplete="off" />
                                <mat-datepicker-toggle matSuffix [for]="expiredToDateRef">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                                        [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #expiredToDateRef></mat-datepicker>
                                <mat-error *ngIf="expiredToDateCtrl?.errors?.matDatepickerParse">
                                    {{'validation.format_of_date' | translate}}
                                </mat-error>
                                <mat-error
                                    *ngIf="expiredToDateCtrl?.errors?.matDatepickerMin && expiredDateErr == 'expiredToDate'">
                                    {{ 'search_form.expired_date_to' | translate }}
                                    {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                                    {{ 'search_form.expired_date_from' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Mã hợp đồng -->
                        <div class="col-sm-4 col-6">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.contractCode = documents.contractCode == undefined ? '' : (documents.contractCode + '').trim()"
                                    #focusInput matInput [placeholder]="'search_form.doc_code' | translate"
                                    name="contractCode" [(ngModel)]="documents.contractCode" maxlength="200"
                                    autocomplete="off">
                                <button mat-button *ngIf="documents.contractCode" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="documents.contractCode=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Tên hợp đồng -->
                        <div class="col-sm-4 col-6">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.contractName = documents.contractName == undefined ? '' : (documents.contractName + '').trim()"
                                    #focusInput matInput [placeholder]="'headertable.doc_name' | translate"
                                    name="contractName" [(ngModel)]="documents.contractName" maxlength="200"
                                    autocomplete="off">
                                <button mat-button *ngIf="documents.contractName" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="documents.contractName=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Tiến độ xử lý của khách hàng -->
                        <div class="col-sm-2 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.processing_progress' | translate}}</mat-label>
                                <mat-select #contractEnterpriseStatusSelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, contractEnterpriseStatusSelect)"
                                    id="contractEnterpriseStatus" name="contractEnterpriseStatus"
                                    [(ngModel)]="documents.contractEnterpriseStatus" multiple>
                                    <mat-option #allSelectedProcess (click)="clickOptionContractEnterpriseStatusAll()">
                                        {{ 'form.choose_all' | translate }}
                                    </mat-option>
                                    <mat-option [value]="EnumContractEnterpriseStatus.PROCESSING"
                                        (click)="clickOptionContractEnterpriseStatus()">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing'
                                        | translate}}</mat-option>
                                    <mat-option [value]="EnumContractEnterpriseStatus.REJECTED"
                                        (click)="clickOptionContractEnterpriseStatus()">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.denied'
                                        | translate}}</mat-option>
                                    <mat-option [value]="EnumContractEnterpriseStatus.SIGNED"
                                        (click)="clickOptionContractEnterpriseStatus()">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.signed'
                                        | translate}}</mat-option>
                                    <mat-option [value]="EnumContractEnterpriseStatus.STOP_PROCESS"
                                        (click)="clickOptionContractEnterpriseStatus()">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress'
                                        | translate}}</mat-option>
                                    <mat-option [value]="EnumContractEnterpriseStatus.WAIT_SETUP_FLOW"
                                        (click)="clickOptionContractEnterpriseStatus()">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow'
                                        | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Trạng thái -->
                        <div class="col-sm-2 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.status' | translate}}</mat-label>
                                <mat-select #statusSelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status"
                                    name="status" [(ngModel)]="documents.status" multiple>
                                    <mat-option #allSelectedStatus (click)="clickOptionStatusAll()">
                                        {{ 'form.choose_all' | translate }}
                                    </mat-option>
                                    <mat-option [value]="EnumContractStatus.PROCESSING" (click)="clickOptionStatus()">
                                        {{'search_form.processing' | translate}}</mat-option>
                                    <mat-option [value]="EnumContractStatus.REJECTED" (click)="clickOptionStatus()">
                                        {{'search_form.denied_sign' | translate}}</mat-option>
                                    <mat-option [value]="EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"
                                        (click)="clickOptionStatus()" *ngIf="isNotAttestedUser">
                                        {{'search_form.wait_confirm_enterprice_no_moit' | translate}}</mat-option>
                                    <mat-option [value]="EnumContractStatus.FINISHED" (click)="clickOptionStatus()">
                                        {{'search_form.finish' | translate}}</mat-option>
                                    <mat-option [value]="EnumContractStatus.CONNECTING" (click)="clickOptionStatus()"
                                        *ngIf="!isNotAttestedUser">
                                        {{'search_form.connecting' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </mat-expansion-panel>
        </mat-accordion>

        <!-- Group and sort -->
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel expanded="true" class="mt-3">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'search_form.sort_and_group' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <form #groupForm="ngForm" class="pb-3">
                    <div class="row">
                        <!-- Trạng thái -->
                        <div class="col-md-4 col-12">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.group' | translate}}</mat-label>
                                <mat-select #groupBySelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, groupBySelect)" id="groupBy"
                                    name="groupBy" [(ngModel)]="documents.groupBy">
                                    <mat-option [value]="null" (click)="commonService.closeDropdownList(groupBySelect)">
                                        {{'search_form.unselect_group' | translate}}</mat-option>
                                    <mat-option value="creatorId"
                                        (click)="commonService.closeDropdownList(groupBySelect)">
                                        {{'search_form.subject_create' | translate}}</mat-option>
                                    <mat-option value="contractEnterpriseStatus"
                                        (click)="commonService.closeDropdownList(groupBySelect)">
                                        {{'search_form.processing_progress' | translate}}</mat-option>
                                    <mat-option value="status" (click)="commonService.closeDropdownList(groupBySelect)">
                                        {{'search_form.status' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Sắp xếp theo -->
                        <div class="col-md-4 col-12">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.sort' | translate}}</mat-label>
                                <mat-select #sortBySelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false; onChangeSortSelection()"
                                    (focus)="commonService.openComboBox(checkFocus, sortBySelect)" id="sortName"
                                    name="sortName" [(ngModel)]="sortName">
                                    <mat-option [value]="null" (click)="unSelectSort()">
                                        {{'search_form.unselect_sort' | translate}}</mat-option>
                                    <mat-option value='expiredDate'
                                        (click)="commonService.closeDropdownList(sortBySelect)">
                                        {{'search_form.end_date' | translate}}</mat-option>
                                    <mat-option value="receiveTime"
                                        (click)="commonService.closeDropdownList(sortBySelect)">
                                        {{'search_form.receive_time' | translate}}</mat-option>
                                    <mat-option value="contractCode"
                                        (click)="commonService.closeDropdownList(sortBySelect)">
                                        {{'search_form.doc_code' | translate}}</mat-option>
                                    <mat-option value="contractName"
                                        (click)="commonService.closeDropdownList(sortBySelect)">
                                        {{'headertable.doc_name' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Loại sắp xếp -->
                        <div class="col-md-4 col-12">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.sort_type' | translate}}</mat-label>
                                <mat-select #sortTypeSelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, sortTypeSelect)" id="sortType"
                                    name="sortType" [(ngModel)]="sortType">
                                    <mat-option value='ASC'
                                        *ngIf="sortName === 'expiredDate' || sortName === 'receiveTime'"
                                        (click)="commonService.closeDropdownList(sortTypeSelect)">
                                        {{'search_form.new_to_old' | translate}}</mat-option>
                                    <mat-option value="DESC"
                                        *ngIf="sortName === 'expiredDate' || sortName === 'receiveTime'"
                                        (click)="commonService.closeDropdownList(sortTypeSelect)">
                                        {{'search_form.old_to_new' | translate}}</mat-option>
                                    <mat-option value="ASC"
                                        *ngIf="sortName === 'contractCode' || sortName === 'contractName'"
                                        (click)="commonService.closeDropdownList(sortTypeSelect)">
                                        {{'A >> Z' | translate}}</mat-option>
                                    <mat-option value="DESC"
                                        *ngIf="sortName === 'contractCode' || sortName === 'contractName'"
                                        (click)="commonService.closeDropdownList(sortTypeSelect)">
                                        {{'Z >> A' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-card-content>
    <div class="row mt-3" style="margin-bottom: 15px;">
        <div class="col-lg-12 d-flex justify-content-center">
            <button mat-raised-button color="primary" type="submit" (click)="onExportReport()"
                [disabled]="!myForm.valid">
                <mat-icon class="mr-0" style="font-weight: 900;">receipt_long</mat-icon>
                {{'total_contract_report.title_btn' | translate}}
            </button>
        </div>
    </div>
</mat-card>
<app-history-report [mode]="mode" [formExport]="exportForm" (filterForm)="filterForm($event)"></app-history-report>
<ng4-loading-spinner *ngIf="showSpinner" [threshold]="1000" [timeout]="100000" [zIndex]="9999"></ng4-loading-spinner>